import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CodeBlock = ({ code, language = 'javascript', title, description }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard?.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  const getLanguageIcon = (lang) => {
    switch (lang?.toLowerCase()) {
      case 'javascript': case'js':
        return 'FileText';
      case 'python':
        return 'Code';
      case 'php':
        return 'FileCode';
      case 'java':
        return 'Coffee';
      case 'curl':
        return 'Terminal';
      default:
        return 'Code';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      {(title || description) && (
        <div className="px-4 py-3 border-b border-border">
          {title && (
            <h4 className="text-sm font-medium text-foreground mb-1">{title}</h4>
          )}
          {description && (
            <p className="text-xs text-muted-foreground">{description}</p>
          )}
        </div>
      )}
      
      <div className="relative">
        <div className="flex items-center justify-between px-4 py-2 bg-muted/30 border-b border-border">
          <div className="flex items-center space-x-2">
            <Icon name={getLanguageIcon(language)} size={14} className="text-muted-foreground" />
            <span className="text-xs font-medium text-muted-foreground uppercase">
              {language}
            </span>
          </div>
          
          <button
            onClick={handleCopy}
            className="flex items-center space-x-1 px-2 py-1 text-xs text-muted-foreground hover:text-foreground bg-background/50 hover:bg-background rounded transition-colors"
          >
            <Icon name={copied ? "Check" : "Copy"} size={12} />
            <span>{copied ? 'Copied!' : 'Copy'}</span>
          </button>
        </div>
        
        <div className="p-4 overflow-x-auto">
          <pre className="text-sm text-foreground font-mono leading-relaxed">
            <code>{code}</code>
          </pre>
        </div>
      </div>
    </div>
  );
};

export default CodeBlock;